var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDerecha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "26d8f5de7d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 101.085938 L 810 101.085938 L 810 746.085938 L 0 746.085938 Z M 0 101.085938 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#26d8f5de7d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 487.003906 746.132812 L 809.527344 423.609375 L 487.003906 101.085938 L 445.636719 142.453125 L 697.136719 394.320312 L 0.472656 394.320312 L 0.472656 452.894531 L 697.136719 452.894531 L 445.636719 704.765625 Z M 487.003906 746.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerecha);
export default __webpack_public_path__ + "static/media/derecha.16d3f4a0f4e15bcbde162c80e6173930.svg";
export { ForwardRef as ReactComponent };